import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, user, loading, role } = useContext(AuthContext);
  const navigate = useNavigate();

const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const loginResult = await login(email, password);
      
      // Use the returned user data for immediate redirection
      if (loginResult && loginResult.role === 'client') {
        navigate('/client-dashboard');
      } else if (loginResult && loginResult.role === 'admin') {
        navigate('/admin-dashboard');
      } else {
        navigate('/app');
      }
    } catch (err) {
      console.error('Login error:', err.code, err.message);
      setError(err.message || 'Invalid email or password');
    }
  };

  useEffect(() => {
    // Removed automatic redirection - now handled manually in handleSubmit
    if (!loading && !user) {
      // No user after loading, staying on login page
    }
  }, [user, loading, navigate]);

  return (
    <div className="login-container">
      <h2>Login</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">Login</button>
      </form>
      
      <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
        <p style={{ margin: '0' }}>
          Don't have an account? <Link to="/register">Register here</Link>
        </p>
        <Link to="/" className="back-to-home-button">
          Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Login;